export default "__VITE_ASSET__Cjf2ojaj__"